import { render, staticRenderFns } from "./FeeCollectionStep.vue?vue&type=template&id=59e0ff93"
import script from "./FeeCollectionStep.vue?vue&type=script&lang=js"
export * from "./FeeCollectionStep.vue?vue&type=script&lang=js"
import style0 from "./FeeCollectionStep.vue?vue&type=style&index=0&id=59e0ff93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports